import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalChatPoNumberDisplayDocument = gql`
  query SalesPortalChatPoNumberDisplay(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    businesses_by_pk(uuid: $supplierUUID) {
      uuid
      supplier_chats(
        where: { restaurant_uuid: { _eq: $restaurantUUID } }
        limit: 1
      ) {
        po_number_display
        uuid
      }
    }
  }
`;
export function useSalesPortalChatPoNumberDisplayQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalChatPoNumberDisplayQuery,
    Types.SalesPortalChatPoNumberDisplayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalChatPoNumberDisplayQuery,
    Types.SalesPortalChatPoNumberDisplayQueryVariables
  >(SalesPortalChatPoNumberDisplayDocument, options);
}
export function useSalesPortalChatPoNumberDisplayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalChatPoNumberDisplayQuery,
    Types.SalesPortalChatPoNumberDisplayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalChatPoNumberDisplayQuery,
    Types.SalesPortalChatPoNumberDisplayQueryVariables
  >(SalesPortalChatPoNumberDisplayDocument, options);
}
export type SalesPortalChatPoNumberDisplayQueryHookResult = ReturnType<
  typeof useSalesPortalChatPoNumberDisplayQuery
>;
export type SalesPortalChatPoNumberDisplayLazyQueryHookResult = ReturnType<
  typeof useSalesPortalChatPoNumberDisplayLazyQuery
>;
export type SalesPortalChatPoNumberDisplayQueryResult = Apollo.QueryResult<
  Types.SalesPortalChatPoNumberDisplayQuery,
  Types.SalesPortalChatPoNumberDisplayQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalChatPoNumberDisplayQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalChatPoNumberDisplayQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalChatPoNumberDisplayQuery,
    Types.SalesPortalChatPoNumberDisplayQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalChatPoNumberDisplayQuery,
    Types.SalesPortalChatPoNumberDisplayQueryVariables
  >(SalesPortalChatPoNumberDisplayDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalChatPoNumberDisplayLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalChatPoNumberDisplayLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalChatPoNumberDisplayQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalChatPoNumberDisplayQuery,
    Types.SalesPortalChatPoNumberDisplayQueryVariables
  >(SalesPortalChatPoNumberDisplayDocument, lazyOptions);
}
